import {
	Dialog,
	DialogBackdrop,
	DialogPanel,
	DialogTitle,
} from '@headlessui/react'
import TypographyHeader from '../typography/TypographyHeading'
import { CloseIcon } from '../icons'
import clsx from 'clsx'
import { ReactNode } from 'react'

const Modal = ({
	size = 'large',
	titleIcon,
	title = '',
	body = <div></div>,
	isOpen = false,
	onClose = () => {},
	showClose = true,
}: {
	size?: string
	titleIcon?: ReactNode
	title?: string
	body?: any
	isOpen: boolean
	onClose: any
	showClose?: boolean
}) => {
	return (
		<Dialog
			open={isOpen}
			transition
			className={clsx(
				// "opacity-100",
				'fixed inset-0 bg-black/25',
				'relative z-40 transition duration-300 ease-out data-[closed]:opacity-0',
			)}
			onClose={() => onClose()}
		>
			<DialogBackdrop className="fixed inset-0 bg-black/60" />
			<div className="fixed inset-0 overflow-y-auto">
				<div className="flex min-h-full items-center justify-center p-4 text-center">
					<DialogPanel
						className={`${
							size == 'xLarge'
								? 'w-full max-w-5xl'
								: size == 'large'
									? 'w-full max-w-xl'
									: size === 'medium'
										? 'w-full max-w-md'
										: size == 'small'
											? 'w-full max-w-sm'
											: size
						} relative transform rounded-2xl bg-grey100 p-10 
                text-left align-middle text-textPrimaryLight shadow-xl drop-shadow
                transition-all dark:bg-uiTertiaryDark dark:text-textPrimaryDark`}
					>
						{showClose && (
							<button
								className="absolute right-4 top-3"
								onClick={onClose ? onClose : () => {}}
							>
								<CloseIcon />
							</button>
						)}
						{titleIcon && (
							<div className="mx-auto flex h-10 w-full items-center justify-center">
								{titleIcon}
							</div>
						)}
						{title && (
							<DialogTitle
								as="div"
								className="text-gray-900 text-lg font-medium leading-6"
							>
								<TypographyHeader
									size="large"
									isBold={true}
									additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark text-center"
								>
									{title}
								</TypographyHeader>
							</DialogTitle>
						)}
						<div className="mt-4">{body}</div>
					</DialogPanel>
				</div>
			</div>
		</Dialog>
	)
}

export default Modal
